import type { SVGProps } from 'react';

const SvgEmoji = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M12 3c-4.96 0-9 4.04-9 9s4.04 9 9 9 9-4.04 9-9-4.04-9-9-9m0 16c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7"
    />
    <path
      fill="currentcolor"
      d="M9.5 11a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m5 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m1.44 2.13c-.48-.28-1.09-.11-1.37.36a2.95 2.95 0 0 1-5.14 0 1 1 0 0 0-1.37-.36c-.48.28-.64.89-.36 1.37.89 1.54 2.54 2.5 4.3 2.5s3.41-.96 4.3-2.5c.28-.48.11-1.09-.36-1.37"
    />
  </svg>
);
export default SvgEmoji;
